// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Ys-z","giftOrPromoSelector":"Zs-z","disabled":"_s-z","subTitle":"at-z","selectShipAddressMessage":"bt-z","changePayment":"ct-z"};